import { api } from './client';
import type { Tag } from '../types';

export const tagsApi = {
  list: () => api.get<{ tags: Tag[] }>('/tags'),
  create: (name: string, colour: string) => api.post<{ tag: Tag }>('/tags', { name, colour }),
  update: (id: number, data: { name?: string; colour?: string }) => api.put<{ tag: Tag }>(`/tags/${id}`, data),
  delete: (id: number) => api.delete<{ success: boolean }>(`/tags/${id}`),
};
